export const wizardsData = {
  registerBirth: {
    id: 'registerBirth',
    steps: 3
  },
  renewPermit: {
    id: 'renewPermit',
    steps: 4
  },
  reportWages: {
    id: 'reportWages',
    steps: 3
  },
  enrollSchool: {
    id: 'enrollSchool',
    steps: 4
  },
  medicalCert: {
    id: 'medicalCert',
    steps: 3
  },
  appealDeportation: {
    id: 'appealDeportation',
    steps: 5
  },
  getWorkPermit: {
    id: 'getWorkPermit',
    steps: 5
  },
  openBankAccount: {
    id: 'openBankAccount',
    steps: 4
  },
  requestLegalAid: {
    id: 'requestLegalAid',
    steps: 4
  },
  reportViolence: {
    id: 'reportViolence',
    steps: 5
  },
  requestAsylum: {
    id: 'requestAsylum',
    steps: 6
  },
  registerMarriage: {
    id: 'registerMarriage',
    steps: 5
  },
  replaceDocuments: {
    id: 'replaceDocuments',
    steps: 4
  },
  accessHealthcare: {
    id: 'accessHealthcare',
    steps: 3
  },
  detentionRights: {
    id: 'detentionRights',
    steps: 5
  },
  findHousing: {
    id: 'findHousing',
    steps: 4
  }
};
